import { useTranslation } from "react-i18next";

import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { DeviceProductCard } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/DeviceProductCard.tsx";
import { getIconForProductCategory } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/ProductCategoryIcon.tsx";
import { SimStatusChip } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/SimStatusChip.tsx";
import { useGetTitle } from "@/hooks/useGetTitle.ts";
import { portalRoutes } from "@/router/routes/portalRoutes.ts";
import { SimCardDetail } from "@/services/model";
import {
  getFlatNameFromDevice,
  hasDisplayableProductDescription,
} from "@/utils/deviceUtils";

interface InactiveProps {
  device: SimCardDetail;
  manageRoute: string;
}

export const InactiveSimTile = ({ device, manageRoute }: InactiveProps) => {
  const { t } = useTranslation("portal");
  const title = useGetTitle(device.alias);
  const icon = getIconForProductCategory(device);

  return (
    <DeviceProductCard
      dataTestid="inactive-sim"
      icon={icon}
      title={title}
      subtitle={
        hasDisplayableProductDescription(device)
          ? getFlatNameFromDevice(device)
          : t("layout.tiles.inactive.noSubscriptionActive")
      }
      navigationTarget={`${manageRoute}?simId=${device.simId}`}
      chips={<SimStatusChip status={device.simStatus} />}
      footer={
        <ProductCardFooterItem
          variant="text-button"
          description={t("layout.tiles.inactive.activateSubscriptionText")}
          label={t("layout.tiles.inactive.activateSubscriptionButton")}
          to={`${portalRoutes.manageDevice.subscription.change}?simId=${device.simId}`}
        />
      }
    />
  );
};
